import { createContext } from 'react';
import type { ContextType } from './types.tsx';

export const context = createContext<ContextType>({
	id: {
		scopeIndex: -1,
		issueId: '',
	},
});
